import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import {
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useContext, useEffect, useState } from "react";
import AppDataContext from "../../../common/appContext";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import Loader from "../../../sharedComponents/loader/loader";
import TitleTooltip from "../../../sharedComponents/Tooltip/TitleTooltip";

const useStyles = makeStyles((theme) => ({
  firstSectionTitle: {
    fontWeight: "500",
    color: "#1d428a",
  },
  label: {
    color: "#8B8B8B",
    wordBreak: "break-all",
  },
  paperStyle: {
    padding: theme.spacing(2),
    marginTop: "15px",
  },
  firstSectionTitle: {
    fontWeight: "500",
    color: "#1d428a",
  },
  height100: {
    height: "100%",
  },
  label: {
    color: "#8B8B8B",
    wordBreak: "break-all",
  },
  paperStyle: {
    padding: theme.spacing(2),
    marginTop: "15px",
  },
}));

const HSEventAndRankingViewUpdate = (props) => {
  const {
    eventId,
    playerID,
    styles,
    highSchoolEventsData,
    rankingsData,
    viewProfile,
    setAlert,
    setAlertType,
    setAlertMessage,
    user,
  } = props;

  const outerUseStyles = makeStyles((theme) => styles);
  const outerClasses = outerUseStyles();
  const innerClasses = useStyles();

  const [commonHSEventsData, setCommonHSEventsData] = useState([]);
  const [commonRankingData, setCommonRankingData] = useState([]);
  const [playerHSEventsData, setPlayerHSEventsData] = useState([]);
  const [playerRankingData, setPlayerRankingData] = useState([]);
  const [rankingYear, setRankingYear] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(async () => {
    fetchHSRankingDataForPlayer();
  }, [highSchoolEventsData, rankingsData]);

  useEffect(() => {
    let updatedHSEvents = commonHSEventsData.map((hs, i) => {
      let result = checkIfHSEventChecked(hs.childID);
      let eventObj = {
        formData: {
          // event object to submit
          // directly on save api call send this formData, no need to extract required key:value
          id: 0,
          userBy: user.loginID,
          mode: "delete",
          playerID: playerID,
          eventId: eventId,
          hsEventId: hs.childID,
          eventName: hs.childName,
          eventYear: null,
        },
        eventChecked: false, //extra info for the events
      };
      return result
        ? {
            formData: {
              ...eventObj.formData,
              id: result.id,
              eventId: result.eventId,
              eventYear: result.eventYear ? parseInt(result.eventYear) : null,
              mode: "",
            },
            eventChecked: true,
          }
        : eventObj;
    });

    let updatedRankingData = commonRankingData.map((r, i) => {
      let result = checkIfRankingChecked(r.childID);
      let rankObj = {
        formData: {
          //ranking object to submit
          //on save api call send this fomrData directly, no need to extract key:value
          id: 0,
          userBy: user.loginID,
          mode: "delete",
          playerID: playerID,
          eventId: eventId,
          rankItemId: r.childID,
          rankItemName: r.childName,
          rankYear: rankingYear,
          rankNumber: null,
        },
        rankChecked: false, //extra info
      };
      return result
        ? {
            formData: {
              ...rankObj.formData,
              id: result.id,
              eventId: result.eventId,
              rankYear: result.rankYear ? parseInt(result.rankYear) : null,
              rankNumber: result.rankNumber
                ? parseInt(result.rankNumber)
                : null,
              mode: "",
            },
            rankChecked: true,
          }
        : rankObj;
    });
    setPlayerHSEventsData(updatedHSEvents);
    setPlayerRankingData(updatedRankingData);
  }, [commonHSEventsData, commonRankingData]);

  //---UTILs---
  //find any ranking event with a rank year, it is common for all events
  const getRankYear = () => {
    let result = rankingsData.find((r, i) => {
      return !isNaN(r.rankYear);
    });
    return result ? parseInt(result.rankYear) : null;
  };

  //check if HS event is checked or not fot view
  //and determine if corresponding year input box disabled
  const checkIfHSEventChecked = (childID) => {
    let result = {};
    result = highSchoolEventsData?.find((hs, i) => {
      return childID === hs.hsEventId && hs.mode !== "delete";
    });
    return result;
  };

  //check if ranking event is checked or not for view
  //and determine if corresponding rank number input box disabled
  const checkIfRankingChecked = (childID) => {
    let result = {};
    result = rankingsData.find((r, i) => {
      return childID === r.rankItemId && r.mode !== "delete";
    });
    return result;
  };

  //---HANDLERS---
  //check or uncheck the selected HS event
  const handleHSEventChange = (e, childID) => {
    let checked = e.target.checked;
    const updatedHSEvents = playerHSEventsData.map((hs, i) => {
      return hs.formData.hsEventId === childID
        ? {
            formData: {
              ...hs.formData,
              eventYear: null,
              mode: !checked ? "delete" : null, //if unchecked, set the mode to delete
            },
            eventChecked: checked,
          }
        : hs;
    });
    setPlayerHSEventsData(updatedHSEvents);
  };

  const handleHSEventYearChange = (e, childID) => {
    const updatedHSEvents = playerHSEventsData.map((hs, i) => {
      return hs.formData.hsEventId === childID
        ? {
            ...hs,
            formData: {
              ...hs.formData,
              eventYear: e.target.value ? e.target.value : null,
            },
          }
        : hs;
    });
    setPlayerHSEventsData(updatedHSEvents);
  };

  //check or uncheck the selected ranking event
  const handleRankingChange = (e, childID) => {
    let checked = e.target.checked;
    const updatedRanking = playerRankingData.map((r, i) => {
      return r.formData.rankItemId === childID
        ? {
            formData: {
              ...r.formData,
              mode: !checked ? "delete" : null, //if unchecked, set the mode to delete
              rankNumber: null,
              rankYear: !checked ? null : rankingYear,
            },
            rankChecked: checked,
          }
        : r;
    });
    setPlayerRankingData(updatedRanking);
  };

  const handleRankingNumberChange = (e, childID) => {
    const updatedRanking = playerRankingData.map((r, i) => {
      return r.formData.rankItemId === childID
        ? {
            ...r,
            formData: {
              ...r.formData,
              rankNumber: e.target.value ? parseInt(e.target.value) : null,
            },
          }
        : r;
    });
    setPlayerRankingData(updatedRanking);
  };

  //Change rank year for all ranking events as it is same for all
  const handleRankYearChange = (e) => {
    let year = e.target.value ? parseInt(e.target.value) : null;
    const updatedRanking = playerRankingData.map((r, i) => {
      return r.formData.mode !== "delete"
        ? {
            ...r,
            formData: {
              ...r.formData,
              rankYear: year,
            },
          }
        : r;
    });
    setPlayerRankingData(updatedRanking);
    setRankingYear(year);
  };

  //---APIs---
  const fetchHSRankingDataForPlayer = async () => {
    try {
      const [highSchoolEvents, rankings] = await Promise.all([
        PlayerProfileService.getHighSchoolEventsData(),
        PlayerProfileService.getRankingsData(),
      ]);
      setCommonHSEventsData(highSchoolEvents.data);
      setCommonRankingData(rankings.data);
      setRankingYear(getRankYear());
    } catch (error) {
      console.error("Failed to fetchHSRankingDataForPlayer data:", error);
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    //extract rquired formData to submit directly, without extra info.
    const hsFormData = playerHSEventsData.map((hs, i) => {
      return hs.formData;
    });
    const rankingFormData = playerRankingData.map((r, i) => {
      return r.formData;
    });

    try {
      const hsEventResponse =
        await PlayerProfileService.insertUpdateHighSchoolEvents(hsFormData);
      const rankingResponse = await PlayerProfileService.insertUpdateRankings(
        rankingFormData
      );

      if (hsEventResponse.data && rankingResponse.data) {
        setAlert(true);
        setAlertType("success");
        setAlertMessage("Data uploaded successfully.");
      }
    } catch (error) {
      console.log(error);
      setAlert(true);
      setAlertType("error");
      setAlertMessage("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading}></Loader>}
      {viewProfile ? (
        <Box pt={2}>
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Paper square className={innerClasses.height100}>
                <Box p={1.5}>
                  <Typography
                    variant="subtitle1"
                    mb={1.5}
                    fontWeight="medium"
                    color="secondary"
                  >
                    High School Events
                  </Typography>
                  <Grid container>
                    <Grid item xs={3}>
                      <Typography component="p" variant="caption">
                        Event Name
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography component="p" variant="caption">
                        Year
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Grid item xs={3}>
                      {playerHSEventsData
                        ? playerHSEventsData.map((elem, i) => {
                            return (
                              <Typography
                                key={`typ_${i}`}
                                component="p"
                                variant="subtitle2"
                                noWrap
                              >
                                {elem.formData.eventName}
                              </Typography>
                            );
                          })
                        : ""}
                    </Grid>
                    <Grid item xs={3}>
                      {playerHSEventsData?.map((elem, i) => {
                        return (
                          <Typography
                            key={`typ_${i}`}
                            component="p"
                            variant="subtitle2"
                            noWrap
                          >
                            {elem.formData.eventYear
                              ? elem.formData.eventYear
                              : "---"}
                          </Typography>
                        );
                      })}
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Paper square className={innerClasses.height100}>
                <Box p={1.5}>
                  <Typography
                    variant="subtitle1"
                    mb={1.5}
                    fontWeight="medium"
                    color="secondary"
                  >
                    Rankings
                  </Typography>
                  <Grid container>
                    <Grid item xs={4}>
                      <Box display="flex" flexDirection="column">
                        <Typography component="p" variant="caption">
                          Year
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      <Box display="flex" flexDirection="column">
                        <Typography component="p" variant="caption">
                          {rankingYear ? rankingYear : "---"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Grid item xs={4}>
                      <Box display="flex" flexDirection="column">
                        <Typography component="p" variant="caption">
                          Event Name
                        </Typography>

                        {playerRankingData?.map((elem, i) => {
                          return (
                            <Typography component="p" variant="subtitle2">
                              {elem.formData.rankItemName}
                            </Typography> //  {gridData.address1 ? gridData.address1 : ""}
                          );
                        })}
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      <Box display="flex" flexDirection="column">
                        <Typography component="p" variant="caption">
                          Ranking
                        </Typography>
                        {playerRankingData?.map((elem, i) => {
                          return (
                            <Typography component="p" variant="subtitle2">
                              {elem.formData.rankNumber
                                ? elem.formData.rankNumber
                                : "---"}
                            </Typography>
                          );
                        })}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Paper elevation={5} className={innerClasses.paperStyle}>
          <Container maxWidth={false} disableGutters>
            <Grid container>
              <Grid item lg={11} md={11} sm={11} xs={11}>
                <Grid
                  container
                  display="flex"
                  justifyContent={"start"}
                  sx={{
                    padding: "0px 15px 15px 15px",
                  }}
                >
                  <Grid item lg={5} md={6} sm={8} xs={12}>
                    <Grid container spacing={3} pb={2}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          noWrap
                          variant={styles.gridSectionTitle.variant}
                          className={outerClasses.gridSectionTitle}
                        >
                          High School Events
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} pb={2}>
                      <Grid item lg={6} md={6} sm={8} xs={8}>
                        <Typography
                          noWrap
                          variant="subtitle2"
                          color="secondary"
                          sx={{
                            textAlign: "right",
                          }}
                        >
                          Event Name
                        </Typography>
                      </Grid>
                      <Grid item lg={4} md={4} sm={4} xs={4}>
                        <Typography
                          noWrap
                          variant="subtitle2"
                          color="secondary"
                          sx={{
                            textAlign: "left",
                          }}
                        >
                          Year
                        </Typography>
                      </Grid>

                      {playerHSEventsData.map((elem, i) => {
                        return (
                          <Grid item sm={12} key={i}>
                            <Grid container spacing={3}>
                              <Grid
                                item
                                lg={6}
                                md={6}
                                sm={8}
                                xs={8}
                                sx={{
                                  display: "flex",
                                  justifyContent: "right",
                                }}
                              >
                                <FormControl size="small" margin="dense">
                                  <FormControlLabel
                                    // value="start"
                                    control={
                                      <Checkbox
                                        size="medium"
                                        color="success"
                                        checked={elem.eventChecked}
                                        onChange={(e) => {
                                          handleHSEventChange(
                                            e,
                                            elem.formData.hsEventId
                                          );
                                        }}
                                        sx={{ alignSelf: "flex-start" }}
                                      />
                                    }
                                    label={
                                      <Typography variant="subtitle2">
                                        {elem.formData.eventName}
                                      </Typography>
                                    }
                                    labelPlacement="start"
                                    className={innerClasses.label}
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item lg={3} md={3} sm={4} xs={4}>
                                <FormControl size="small" margin="dense">
                                  <TextField
                                    size="small"
                                    type={"number"}
                                    value={elem.formData.eventYear || ""}
                                    disabled={!elem.eventChecked}
                                    onChange={(e) => {
                                      handleHSEventYearChange(
                                        e,
                                        elem.formData.hsEventId
                                      );
                                    }}
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>

                  {/* Rankings */}

                  <Grid item lg={5} md={6} sm={8} xs={12}>
                    <Grid container spacing={3} pb={2}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          noWrap
                          variant={styles.gridSectionTitle.variant}
                          className={outerClasses.gridSectionTitle}
                        >
                          Rankings
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} pb={2}>
                      <Grid
                        item
                        lg={4}
                        md={4}
                        sm={8}
                        xs={8}
                        sx={{
                          alignSelf: "center",
                          textAlign: "right",
                        }}
                      >
                        <Typography
                          noWrap
                          variant="subtitle2"
                          component="span"
                          color="secondary"
                        >
                          Year
                        </Typography>
                      </Grid>
                      <Grid item lg={3} md={4} sm={4} xs={4}>
                        <TextField
                          size="small"
                          value={rankingYear || ""}
                          onChange={handleRankYearChange}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} pb={2}>
                      <Grid item lg={4} md={4} sm={8} xs={8}>
                        <Typography
                          noWrap
                          variant="subtitle2"
                          color="secondary"
                          sx={{
                            textAlign: "right",
                          }}
                        >
                          Event Name
                        </Typography>
                      </Grid>
                      <Grid item lg={4} md={4} sm={4} xs={4}>
                        <Typography
                          noWrap
                          variant="subtitle2"
                          color="secondary"
                          sx={{
                            textAlign: "left",
                          }}
                        >
                          Ranking
                        </Typography>
                      </Grid>
                    </Grid>
                    {playerRankingData.map((elem, i) => {
                      return (
                        <Grid item sm={12} key={i}>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              lg={4}
                              md={4}
                              sm={8}
                              xs={8}
                              sx={{
                                display: "flex",
                                justifyContent: "right",
                              }}
                            >
                              <FormControl size="small" margin="dense">
                                <FormControlLabel
                                  value="start"
                                  control={
                                    <Checkbox
                                      size="medium"
                                      color="success"
                                      checked={elem.rankChecked}
                                      onChange={(e) =>
                                        handleRankingChange(
                                          e,
                                          elem.formData.rankItemId
                                        )
                                      }
                                      sx={{ alignSelf: "flex-start" }}
                                    />
                                  }
                                  label={
                                    <Typography variant="subtitle2">
                                      {elem.formData.rankItemName}
                                    </Typography>
                                  }
                                  labelPlacement="start"
                                  className={innerClasses.label}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item lg={2} md={3} sm={3} xs={3}>
                              <FormControl
                                size="small"
                                // fullWidth
                                margin="dense"
                              >
                                <TextField
                                  size="small"
                                  value={elem.formData.rankNumber || ""}
                                  type="number"
                                  disabled={!elem.rankChecked}
                                  onChange={(e) =>
                                    handleRankingNumberChange(
                                      e,
                                      elem.formData.rankItemId
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                lg={1}
                md={1}
                sm={1}
                xs={1}
                sx={{ textAlign: "right" }}
              >
                <TitleTooltip title="Save event and ranking details">
                  <Button
                    className={outerClasses.saveButton}
                    size={outerClasses.submitButtonSize}
                    variant={styles.saveButton.variant}
                    title={styles.saveButton.title}
                    onClick={handleSubmit}
                  >
                    <SaveOutlinedIcon />
                  </Button>
                </TitleTooltip>
              </Grid>
            </Grid>
          </Container>
        </Paper>
      )}
    </>
  );
};

export default React.memo(HSEventAndRankingViewUpdate);
